import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { ProductTransactionFlow } from '../../../../../store/transactionFlow/types';
import { Fields } from '../../../constants';

import { CardProductItemDesktop } from './components/Desktop';
import { CardProductItemMobile } from './components/Mobile';

export interface CardListItemProps {
  label: string;
  color: string;
  renderFields: Fields[];
  hasButtonDetails?: boolean;
  onPressDetails?: () => void;
  productDefinition: ProductTransactionFlow;
  productData: any;
}

export const CardProductItem: React.FC<CardListItemProps> = (props) => {
  return useBreakpointValue({
    base: <CardProductItemMobile {...props} />,
    sm: <CardProductItemDesktop {...props} />,
  });
};
